import React from 'react';
import {HeaderProps} from './Header.props';
import './Header.styles.css';

const Header: React.FC<HeaderProps> = () => {
   const showSidebar = () =>{
      const sidebar = document.getElementById('sidebar'),
            header = document.getElementById('header'),
            main = document.getElementById('main');

      sidebar?.classList.toggle('show-sidebar')
      header?.classList.toggle('left-pd')
      main?.classList.toggle('left-pd')
   }

   return (
      <header className="header" id="header">
         <div className="header__container">
            <div className="headerw__logo">
               <span>Cloud</span>
            </div>
            
            <button className="header__toggle" id="header-toggle" onClick={showSidebar}>
               <i className="ri-menu-line"></i>
            </button>
         </div>
      </header>
    );
};

export default Header;